import { render, staticRenderFns } from "./project-media-preview.vue?vue&type=template&id=039fd1e0&scoped=true"
import script from "./project-media-preview.vue?vue&type=script&lang=js"
export * from "./project-media-preview.vue?vue&type=script&lang=js"
import style0 from "./project-media-preview.vue?vue&type=style&index=0&id=039fd1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039fd1e0",
  null
  
)

export default component.exports